export const toKebabCase = (str: string): string => {
  return str
    .replace(/[\s_]+/g, "-")             // Replace spaces and underscores with hyphens
    .replace(/[^a-zA-Z0-9-]/g, "")       // Remove special characters except hyphens
    .toLowerCase();                      // Convert to lowercase
};